<template lang="pug">
.set-password(@keyup.enter="setPassword")
  .set-password__content
    .set-password__form
      .set-password__title {{ $t('设置密码') }}
      .set-password__rule {{ $t('密码至少8位，且必须包含字母、符号和数字') }}
      .set-password__account
        span {{ $t('账号') }} :
        span {{ account }}
      .set-password__password
        span {{ $t('输入密码') }} :
        input(
          type="password"
          v-model="password"
        )
      .set-password__strength
        div(:style="{ backgroundColor: strength > 0 ? '#4ab7e2' : '#d8d8d8' }")
        div(:style="{ backgroundColor: strength > 1 ? '#4ab7e2' : '#d8d8d8' }")
        div(:style="{ backgroundColor: strength > 2 ? '#4ab7e2' : '#d8d8d8' }")
        span {{ strength > 2 ? $t("强") : strength > 1 ? $t("中") : strength > 0 ? $t("弱") : $t("极弱") }}
      .set-password__confirm__password
        span {{ $t('确认密码') }} :
        input(
          type="password"
          v-model="confirmPassword"
        )
      .set-password__button(@click="setPassword") {{ $t('保存') }}
</template>

<script>
import { format4backend } from '@/umcc/util'
import qs from 'qs'
import axios from 'axios'

export default {
  data () {
    return {
      password: '',
      confirmPassword: '',
      loading: false,
      strength: 0
    }
  },
  computed: {
    account () {
      return qs.parse(location.search.substring(1)).mail
    }
  },
  watch: {
    password () {
      this.calcPswStrength()
    }
  },
  methods: {
    calcPswStrength () {
      const p = this.password
      if (p.length < 8) {
        this.strength = 0
      } else {
        let s = 0
        if (p.match(/([a-z])+/)) s++
        if (p.match(/([0-9])+/)) s++
        if (p.match(/[^a-zA-Z0-9]+/)) s++
        this.strength = s
      }
    },
    setPassword () {
      if (!this.validateInfo()) return
      const params = {
        mail: qs.parse(location.search.substring(1)).mail,
        password: this.confirmPassword,
        md5_code: qs.parse(location.search.substring(1)).md5_code,
        service_type: 1
      }
      axios
        .post('/admin/user/changePasswordFromEmail', format4backend(params))
        .then((res) => {
          this.$message.success(this.$t('密码设置成功，即将跳转至登录页'))
          this.$store.commit('common/setUser', null)
          setTimeout(_ => this.$router.push('/login'), 3000)
        })
    },
    validateInfo () {
      if (this.password === '' || this.confirmPassword === '') {
        this.$message.error(this.$t('输入不得为空'))
        return false
      }
      if (this.password !== this.confirmPassword) {
        this.$message.error(this.$t('两次输入的密码需一致'))
        return false
      }
      if (this.strength < 3) {
        this.$message.error(this.$t('请输入正确格式的密码'))
        return false
      }
      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
.set-password
  display flex
  justify-content center
  height 100vh
  background-image url("./assets/bg.png")
  background-repeat no-repeat
  background-size 100vw 100vh

.set-password__content
  width 397px
  margin-top 160px

.set-password__title
  text-align: center
  color: $main
  font-size: 38px
  font-weight 500
  margin-bottom 12px

.set-password__rule
  font-size 20px
  color $main
  margin-bottom 20px
  text-align center

.set-password__account
  color #7d8085
  font-size 20px
  margin-bottom 20px
  > span:nth-child(1)
    text-align left
    margin-right 10px
    display: inline-block

.set-password__password
.set-password__confirm__password
  display flex
  align-items center
  height: 60px
  border-radius: 6px
  box-shadow: 0 0 12px 0 rgba(167, 181, 204, 0.38)
  background-color: #ffffff
  > span
    color #7d8085
    font-size 20px
    display inline-block
    text-align left
    margin 0px 10px
  > input
    letter-spacing 1px
    border none
    font-size 18px
    background-color transparent
    outline none
    &::placeholder
      color #c9ccd2
    &:-webkit-autofill
      transition background-color 5000s ease-in-out 0s

.set-password__password
  margin-bottom 13px

.set-password__confirm__password
  margin-bottom 56px

.set-password__button
  width: 386px
  height: 60px
  border-radius: 6px
  background-color: #3370d2
  display flex
  justify-content center
  align-items center
  color white
  cursor pointer
  font-size 24px

.set-password__strength
  display flex
  align-items center
  color #fff
  margin-bottom 23px
  > div
    height 12px
    width 35px
    margin-right 6px
</style>
